import BaseMfaVerifyCustomizer from './base';
import ProxyFooter from '../../components/common/ProxyFooter';
import WebAuthnVerifyButton from '../../components/mfa-verify/WebAuthnVerifyButton';
import WebAuthnVerifyInfo from '../../components/mfa-verify/WebAuthnVerifyInfo';
import { AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT, MFA_CHALLENGE_EVENT_PREFIX } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { getOktaWidgetModel } from '../../utils/widget-facade';

export default class MfaVerifyWebAuthnCustomizer extends BaseMfaVerifyCustomizer {
  alwaysDisplayBackToLogin = true;
  async shouldCustomize() {
    return this.context?.controller === 'mfa-verify-webauthn';
  }

  protected forgifyController() {
    AmplitudeUtils.logMfaChallengeEvent(`Landing::${AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT[this.context.authenticatorKey]}FactorSelect`);
    this.forgifyVerifyInfo();
    this.forgifyVerifyButton();
    this.onFidoVerificationError();
    super.forgifyController();
  }

  protected getFooter({ footerLink }: { footerLink: JQuery }) {
    return (
      <div className="fe_u_margin--top-large">
        <ProxyFooter
          text={this.footerText}
          footerLinks={footerLink.not('[data-se="cant-verify"]')}
          alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
        />
      </div>
    );
  }

  private forgifyVerifyInfo() {
    const oktaVerifyText = jQueryCourage('.idx-webauthn-verify-text').parent()
      .hide();
    this.renderForgeAndHideOktaComponent({
      id: 'webauthn-verify-info',
      oktaComponent: oktaVerifyText,
      forgeComponent: <WebAuthnVerifyInfo />,
    });
  }

  private forgifyVerifyButton() {
    const retryButton = jQueryCourage('.retry-webauthn');
    this.renderForgeAndHideOktaComponent({
      id: 'webauthn-verify-button',
      oktaComponent: retryButton,
      forgeComponent: <WebAuthnVerifyButton oktaButton={retryButton} />,
    });
  }
  private onFidoVerificationError() {
    const widgetModel = getOktaWidgetModel();
    widgetModel.on('error', (_: any, error: any) => {
      if (this.context?.controller === 'mfa-verify-webauthn') {
        AmplitudeUtils.logCustomEvent(`${MFA_CHALLENGE_EVENT_PREFIX}WebAuthn::Error`, { error });
      }
    });
  }
}
